<div class="kyc-wrapper">

  <div class="kyc-section-inner">
    <div class="kyc-subsection-header">
      <span class="kyc-subsection-title">KYC Documents</span>
      <div class="kyc-header-actions">
        <button mat-icon-button type="button" (click)="addDocumentRow()"
                *ngIf="!disableTable" matTooltip="Add Row" class="kyc-add-btn">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>

    <div class="kyc-table-wrapper">
    <table class="document_list" mat-table [dataSource]="documentDataSource" [ngClass]="{'row-disabled':disableTable}">

      <!-- Document Code -->
      <ng-container matColumnDef="documentCode">
        <th mat-header-cell *matHeaderCellDef>Document Code</th>
        <td mat-cell *matCellDef="let element">
          <span class="doc-code">{{element.documentCode}}</span>
        </td>
      </ng-container>

      <!-- Document Name -->
      <ng-container matColumnDef="documentName">
        <th mat-header-cell *matHeaderCellDef>Document Name</th>
        <td mat-cell *matCellDef="let element">
          <mat-select class="doc-name-select"
              [(ngModel)]="element.documentCode"
              (ngModelChange)="onDocumentCodeChange($event, element)"
              (openedChange)="clearRowSearch(element._rowId)"
              placeholder="Select document" [disabled]="disableTable">
            <mat-option>
              <ngx-mat-select-search [formControl]="getRowSearchCtrl(element._rowId)"
                placeholderLabel="Search document..."
                noEntriesFoundLabel="No documents found">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let doc of getRowFilteredDocs(element._rowId)" [value]="doc.code">
              {{doc.name}}<span *ngIf="element.isMandatory && doc.code === element.documentCode" class="red-color"> *</span>
            </mat-option>
          </mat-select>
        </td>
      </ng-container>

      <!-- Upload -->
      <ng-container matColumnDef="uploadDocument">
        <th mat-header-cell *matHeaderCellDef>Upload</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="!element.fileExists">
            <mat-icon class="upload-icon cursor" (click)="onUploadClick(element, fileInput)" [class.disabled-icon]="disableTable">cloud_upload</mat-icon>
            <input type="file" hidden #fileInput accept=".pdf,.jpg,.jpeg,.png"
                   (change)="filesSelected(element, $event.target['files'])" [disabled]="disableTable"/>
          </ng-container>
          <ng-container *ngIf="element.fileExists">
            <div class="uploaded-file-cell">
              <mat-icon class="uploaded-icon">cloud_done</mat-icon>
              <span class="uploaded-file-name" *ngIf="element.newFileName || element.oldFileName"
                    [matTooltip]="element.newFileName || element.oldFileName">
                {{ element.newFileName || element.oldFileName }}
              </span>
              <mat-icon class="preview-icon" matTooltip="Preview" (click)="previewFile(element)">visibility</mat-icon>
              <mat-icon class="download-icon" matTooltip="Download" (click)="downloadKycFile(element)">file_download</mat-icon>
            </div>
          </ng-container>
        </td>
      </ng-container>

      <!-- KYC Done By -->
      <ng-container matColumnDef="kycDoneBy">
        <th mat-header-cell *matHeaderCellDef>KYC Done By</th>
        <td mat-cell *matCellDef="let element">{{element.kycDoneBy}}</td>
      </ng-container>

      <!-- Date & Time -->
      <ng-container matColumnDef="kycDateTime">
        <th mat-header-cell *matHeaderCellDef>Date & Time</th>
        <td mat-cell *matCellDef="let element">{{element.kycDateTime}}</td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element; let i = index">
          <!-- Only allow deleting rows that have not yet been saved (no _docId).
               Persisted KYC entries cannot be removed in edit mode. -->
          <span class="__action_delete_icon" (click)="deleteDocumentRow(i)"
                *ngIf="!disableTable && element._docId == null" matTooltip="Delete">
            <mat-icon>delete</mat-icon>
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    </div>
  </div>

  <div class="kyc-actions" *ngIf="!buttonHidden">
    <button mat-button color="primary" (click)="onSave()">Save</button>
    <button mat-button color="cancel" (click)="onCancel()">Cancel</button>
  </div>

</div>
